import React, { useState, useEffect, useRef } from "react";
import './slides.css';

function Slider() {
    const [activeSlide, setActiveSlide] = useState(0);
    const sectionRef = useRef(null);
    const slideRefs = useRef([]);
    
    const slides = [
        {
            number: "01",
            title: "Overview",
            description: "Penny is a tool that helps you get a overview of your economy and find the information you need.",
            content: "Dashboard"
        },
        {
            number: "02",
            title: "Planner",
            description: "Our planner helps you save through optimizing your shopping list and make sure you are on track to achieve your goals.",
            content: "Planner"
        },
        {
            number: "03",
            title: "Saved Recipes",
            description: "Save your favorite recipes, make sure you can find them again and create your own cookbooks to share with your friends.",
            content: "Cookbook"
        },
        {
            number: "04",
            title: "Market",
            description: "Find the inspiration for your recipes from other creators through our market.",
            content: "Market"
        }
    ];

    // Handle click on slide numbers
    const handleSlideClick = (index) => {
        const slideElement = slideRefs.current[index];
        if (slideElement) {
            slideElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    // Handle scroll behavior
    useEffect(() => {
        const handleScroll = () => {
            if (!sectionRef.current) return;
            
            // Find which slide is currently most visible in the viewport
            let maxVisibleArea = 0;
            let mostVisibleSlideIndex = activeSlide;
            
            slideRefs.current.forEach((slideEl, index) => {
                if (!slideEl) return;
                
                const rect = slideEl.getBoundingClientRect();
                const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
                const visibleArea = Math.max(0, visibleHeight) / rect.height;
                
                if (visibleArea > maxVisibleArea) {
                    maxVisibleArea = visibleArea;
                    mostVisibleSlideIndex = index;
                }
            });
            
            if (mostVisibleSlideIndex !== activeSlide) {
                setActiveSlide(mostVisibleSlideIndex);
            }
        };

        window.addEventListener('scroll', handleScroll);
        // Initial check
        handleScroll();
        
        return () => window.removeEventListener('scroll', handleScroll);
    }, [activeSlide]);

    return (
        <div className="penny-slider-section" ref={sectionRef}>
            <div className="penny-navigation">
                {slides.map((slide, index) => (
                    <div 
                        key={slide.number}
                        className={`penny-slide-number ${activeSlide === index ? 'penny-slide-active' : ''}`}
                        onClick={() => handleSlideClick(index)}
                    >
                        <span className="penny-slide-number-text">{slide.number}</span>
                        <span className="penny-slide-title">{slide.title}</span>
                    </div>
                ))}
            </div>
            
            <div className="penny-content">
                {slides.map((slide, index) => (
                    <div 
                        key={slide.number} 
                        className="penny-slide"
                        ref={el => slideRefs.current[index] = el}
                    >
                        <div className="penny-slide-inner">
                            <div className="penny-window-frame">
                                <div className="penny-window-header">
                                    <div className="penny-window-buttons">
                                        <span className="penny-window-button penny-button-red"></span>
                                        <span className="penny-window-button penny-button-yellow"></span>
                                        <span className="penny-window-button penny-button-green"></span>
                                    </div>
                                    <div className="penny-window-title">Penny - {slide.content}</div>
                                </div>
                                <div className="penny-window-content">
                                    <div className="penny-window-content-inner">                                
                                        <div className="penny-window-content-body">
                                            <div className="penny-window-content-row">
                                                <div className="penny-window-content-cell">
                                                    {index === 0 && <img src='../images/dashboard.png' alt="Dashboard" />}
                                                    {index === 1 && <img src='../images/stores.png' alt="Stores" />}
                                                    {index === 2 && <img src='../images/cookbook.png' alt="Cookbook" />}
                                                    {index === 3 && <img src='../images/market.png' alt="Market" />}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="penny-slide-description">
                                <h2>{slide.title}</h2>
                                <p>{slide.description}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Slider;
